/* +-----------------------------------------+
|           IMPORTS AREA             		 |
+-----------------------------------------+ */

// CSS
import "../scss/frontend.scss";

// Elementor
import setParallax from "./libs/elementor/setParallax";
import removeInert from "./libs/elementor/removeInert";
import betterHeadlineDynamic from "./libs/elementor/betterHeadlineDynamic";
import arrowReplacer from "./libs/elementor/arrowReplacer";
import officesMap from "./libs/elementor/officesMap";
import paginationTweaker from "./libs/elementor/paginationTweaker";
import historySwiper from "./libs/elementor/historySwiper";
import addAttrToHref from "./libs/elementor/addAttrToHref";

// GSAP
import initGsap from "./libs/gsap/initGsap";
import initTriggers from "./libs/gsap/initTriggers";
import { scrollTo } from "./libs/gsap/gsapUtils";

// Utilities
import exitLoader from "./utils/exitLoader";
import getDimensions from "./utils/getDimensions";
import initOffcanvas from "./utils/initOffcanvas";
import getScrollProgress from "./utils/getScrollProgress";
import initVideos from "./utils/initVideos";
import typeWritter from "./utils/typeWritter";
import accordion from "./utils/accordion";

/* +-----------------------------------------+
|           EVENTS AREA             		 |
+-----------------------------------------+ */

// DOC Ready
function documentReady() {
    initOffcanvas();
    initVideos();

    getDimensions("#site-header", "height");
    betterHeadlineDynamic();
    arrowReplacer();

    setParallax();
    initGsap();
    initTriggers();
    typeWritter();
    historySwiper();

    if(location.hash) {
        scrollTo(document.querySelector(location.hash));
    }

    if( document.body.classList.contains('career-template-default') ) {
        addAttrToHref();
    }
}
document.addEventListener("DOMContentLoaded", documentReady, false);

// WINDOW Load
function windowLoad() {
    getDimensions("#site-footer", "height");
    getDimensions(".iti__flag-container", "width");

    removeInert();
    officesMap();

    paginationTweaker();
    accordion();

    let careerTitle = document.querySelector('.career__form--title');
    let careerInput = document.querySelector('input[name="field_21"]');
    if( careerTitle && careerInput ) {
        careerInput.value = careerTitle.innerHTML;
    }
    
    exitLoader("#siteLoader");
}
window.addEventListener("load", windowLoad, false);

// WINDOW Scroll
function windowScroll() {
    getScrollProgress();
}
window.addEventListener("scroll", windowScroll, { passive: true });

// WINDOW Resize
// function windowResize() {}
// window.addEventListener("resize", windowResize, false);
